// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.WebRtcAnswer in webRtc/webRtc.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.sanitize
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Live view configuration message
 *
 * @property sdp Session description protocol
 * @property type Session type and description
 */
public class WebRtcAnswer(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val sdp: String = "",
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 1,
  )
  public val type: String = "",
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<WebRtcAnswer, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is WebRtcAnswer) return false
    if (unknownFields != other.unknownFields) return false
    if (sdp != other.sdp) return false
    if (type != other.type) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + sdp.hashCode()
      result = result * 37 + type.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """sdp=${sanitize(sdp)}"""
    result += """type=${sanitize(type)}"""
    return result.joinToString(prefix = "WebRtcAnswer{", separator = ", ", postfix = "}")
  }

  public fun copy(
    sdp: String = this.sdp,
    type: String = this.type,
    unknownFields: ByteString = this.unknownFields,
  ): WebRtcAnswer = WebRtcAnswer(sdp, type, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<WebRtcAnswer> = object : ProtoAdapter<WebRtcAnswer>(
      FieldEncoding.LENGTH_DELIMITED, 
      WebRtcAnswer::class, 
      "type.googleapis.com/vreo.volt.protocol.WebRtcAnswer", 
      PROTO_3, 
      null, 
      "webRtc/webRtc.proto"
    ) {
      override fun encodedSize(`value`: WebRtcAnswer): Int {
        var size = value.unknownFields.size
        if (value.sdp != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(1, value.sdp)
        }
        if (value.type != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(2, value.type)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: WebRtcAnswer) {
        if (value.sdp != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 1, value.sdp)
        }
        if (value.type != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 2, value.type)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: WebRtcAnswer) {
        writer.writeBytes(value.unknownFields)
        if (value.type != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 2, value.type)
        }
        if (value.sdp != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 1, value.sdp)
        }
      }

      override fun decode(reader: ProtoReader): WebRtcAnswer {
        var sdp: String = ""
        var type: String = ""
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> sdp = ProtoAdapter.STRING.decode(reader)
            2 -> type = ProtoAdapter.STRING.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return WebRtcAnswer(
          sdp = sdp,
          type = type,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: WebRtcAnswer): WebRtcAnswer = value.copy(
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
